import logo from './logo.svg';
import './App.css';
import MainPage from './pages/MainPage';
import { Route, Routes } from "react-router-dom"
import About from './pages/About';
import ChooseLevel from './pages/ChooseLevel';
import ExploreGame from './pages/ExploreGame';
import ComfortableGame from './pages/ComfortableGame';
import OpenGame from './pages/OpenGame';
import Contestants from './pages/Contestants';
import SettingsPage from './pages/SettingsPage';
import Login from './pages/account/Login';
import Router from './Router';
import { AuthContextProvider } from './auth'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useEffect } from 'react';


const theme = createTheme({
  palette: {
    primary: {
      main: "#E91E63", // Your theme's primary color
    },
    background: {
      default: "#000000", // Your theme's background color
    },
  },
})

function App() {
  useEffect (() => {
    const lockOrientation = async () => {
      try {
        if (window.screen.orientation?.lock) {
          await window.screen.orientation.lock("portrait");
          console.log("Orientation locked to portrait");
        }
      } catch (err) {
        console.warn("Screen orientation lock failed:", err);
      }
    };

    // Only try to lock if app is installed (PWA)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) {
      lockOrientation();
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AuthContextProvider>
        <Router />
      </AuthContextProvider>
    </ThemeProvider>
    // <div >
    //     <Routes>
    //       <Route path="/" element={<MainPage />} />
    //       <Route path="/settingspage" element={<SettingsPage />} />
    //       <Route path="/contestants" element={<Contestants />} />
    //       <Route path="/about" element={<About />} />
    //       <Route path="/chooselevel" element={<ChooseLevel />} />
    //       <Route path="/exploregame" element={<ExploreGame />} />
    //       <Route path="/comfortgame" element={<ComfortableGame />} />
    //       <Route path="/opengame" element={<OpenGame />} />
    //       <Route path="/login" element={<Login />} />
    //     </Routes>
    // </div>
  );
}

export default App;
